import { makeStyles } from "@material-ui/styles";
import { colors } from "../../theme/variables";

export const useStyles = makeStyles({
  adminLayout: {
    display: "grid",
    position: "relative",
    gap: "24px",
    height: "100%",
    overflow: "hidden",
  },
  adminMain: {
    padding: "0px",
    display: "flex",
    flexDirection: "column",
    // Ensure children like grids can shrink properly inside
    minHeight: 0,
  },
  adminHeader: {
    display: "flex",
    gap: "20px",
  },
  menuBtn: {
    width: "48px",
    height: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    cursor: "pointer",
    border: "1px solid #e5e7eb ",
    transition: "background-color 0.2s",
    flexShrink: "0",
    margin: "5px",
  },
  adminHeaderContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "10px",

    // flex: 1,  alignItems: 'flex-start', padding: '10px'
  },
  adminHeaderTitle: {
    color: "#111827",
    margin: 0,
    fontSize: "18px",
    fontWeight: 500,
  },
  adminHeaderSubtitle: {
    color: "#6b7280",
    margin: "4px 0 0 0",
    fontSize: "14px",
  },
  menuList: {
    overflow: "auto",
    paddingRight: "6px", // room for scrollbar
    display: "grid",
    gridGap: "12px", // in MUI v4 use gridGap instead of gap
  },
  // MUI ListItem styles for MenuOptions
  menuListItem: {
    marginBottom: "12px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f8fafc",
      borderColor: "#cbd5e1",
    },
    "&.Mui-selected": {
      backgroundColor: "#0083C2 !important",
      borderColor: "#0083C2",
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "#0083C2 !important",
      },
      "& .MuiListItemIcon-root": {
        color: "#ffffff",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        borderRadius: "8px",
        minWidth: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      "& .MuiListItemText-primary": {
        color: "#ffffff !important",
        fontWeight: 500,
      },
    },
  },
  // MenuOption styles
  menuItem: {
    display: "grid",
    gridTemplateColumns: "40px 1fr",
    gap: "12px",
    padding: "12px",
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    textAlign: "left",
    cursor: "pointer",
    transition: "background 0.2s, border-color 0.2s, transform 0.05s",
    "&:hover": {
      borderColor: "#cbd5e1",
      backgroundColor: "#f8fafc",
    },
    "&:active": {
      transform: "translateY(1px)",
    },
    "&.selected": {
      backgroundColor: "#0083C2",
      borderColor: "#0083C2",
      color: "#ffffff",
      "& .menu-item-title": {
        color: "#ffffff",
      },
      "& .menu-item-icon": {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        color: "#ffffff",
      },
    },
    "&.disabled": {
      opacity: 0.8,
      cursor: "not-allowed",
    },
  },
  menuItemIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    backgroundColor: "#f1f5f9",
    display: "grid",
    placeItems: "center",
    fontSize: "20px",
    transition: "background-color 0.2s, color 0.2s",
  },
  menuItemHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  menuItemTitle: {
    color: "#0f172a",
    fontWeight: 600,
    transition: "color 0.2s",
  },
  menuItemDesc: {
    color: "#64748b",
    fontSize: "12px",
    marginTop: "2px",
  },
  statusPill: {
    fontSize: "11px",
    padding: "2px 8px",
    borderRadius: "999px",
    border: "1px solid transparent",
    "&.active": {
      color: "#065f46",
      backgroundColor: "rgba(16, 185, 129, 0.15)",
      borderColor: "rgba(5, 150, 105, 0.25)",
    },
    "&.soon": {
      color: "#475569",
      backgroundColor: "rgba(148, 163, 184, 0.15)",
      borderColor: "rgba(148, 163, 184, 0.3)",
    },
    "&.small": {
      fontSize: "12px",
      padding: "4px 8px",
    },
  },
  ModuleNotFound: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "400px",
    borderRadius: "12px",
    margin: "20px",
    padding: "40px 20px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "500",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    "&::before": {
      content: '"⚠️"',
      fontSize: "48px",
      marginBottom: "16px",
      display: "block",
    },
  },
});
